<template>
  <div class="race-info">
    <span>Current Party: <span :style="`color: ${currentPartyColor};`">{{ currentParty }}</span></span>

    <span>
      Contested:

      <v-icon
        v-if="isContested"
        style="color: #57aea6;">
        mdi-check
      </v-icon>

      <v-icon
        v-else
        :style="`color: ${ gopColor };`">
        mdi-close
      </v-icon>
    </span>

    <span>
      Open Seat:

      <v-icon
        v-if="openSeat"
        style="color: #57aea6;">
        mdi-check
      </v-icon>

      <v-icon
        v-else
        :style="`color: ${ gopColor };`">
        mdi-close
      </v-icon>
    </span>

    <span>Partisan Lean: <span class="pvi" :style="`color: ${PVIColor};`">{{ PVI }}</span></span>
  </div>
</template>

<script>
const props = {
  currentParty: {
    default: "Dem",
    required: true,
    type: String,
  },
  isContested: {
    default: true,
    required: true,
    type: Boolean,
  },
  openSeat: {
    default: false,
    required: true,
    type: Boolean,
  },
  PVI: {
    default: "R+9",
    required: true,
    type: String,
  },
};

const computed = {
  currentPartyColor() {
    return this.currentParty === "GOP" ? this.gopColor : this.demColor;
  },
  PVIColor() {
    if (this.PVI.includes("R")) return this.gopColor;
    if (this.PVI.includes("D")) return this.demColor;
    return "inherit";
  },
};

export default {
  props,
  computed,
  data: () => ({
    demColor: "#4575a1",
    gopColor: "#d84b44",
  }),
};
</script>

<style scoped>
:root {
  --blue: #4575a1;
  --green: #57aea6;
  --purple: #854c79;
  --red: #d84b44;
}
.race-info {
  display: flex;
  gap: 1rem;
  padding: .5em 0;
  justify-content: center;
}

.pvi {
  text-decoration: underline;
}
</style>
